import React, { useCallback, useMemo, useState } from 'react'

import { Button, Popover, Checkbox } from 'antd'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import { isString } from 'lodash'

import TooltipIconButton from './TooltipIconButton'
import IconButton from './IconButton'

import '../../../assets/quotas.scss'

const localStorage = window.localStorage

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const PopoverIconButton = ({ actions, className = '', content, disabled, icon, text, title, tooltipTitle, trigger, type, onConfirm, t, storageKey }) => {
  const [visible, setVisible] = useState(false)
  const [checkedItem, setCheckedItem] = useState(isString(storageKey) ? !!JSON.parse(localStorage.getItem(storageKey)) : false)

  const onSetVisble = () => {
    if (JSON.parse(localStorage.getItem(storageKey))) {
      onConfirm()
    } else {
      setVisible(true)
    }
  }

  const handleStorageChange = useCallback(() => {
    setCheckedItem(!checkedItem)
    localStorage.setItem(storageKey, JSON.stringify(!checkedItem))
  }, [checkedItem, storageKey])

  const popoverContent = useMemo(() => (
    <div>
      <div className='popover-icon-button-content'>
        {t(content)}
        {isString(storageKey) && (
          <div>
            <Checkbox checked={checkedItem} onChange={handleStorageChange} />
            &nbsp;
            <span>{t('common.hide_message')}</span>
          </div>
        )}
      </div>
      <div className='popover-icon-button-default-actions'>
        <div className='popover-icon-button-action'>
          <Button
            key='card-save-button'
            onClick={onConfirm}
          >
            {t('Yes')}
          </Button>
        </div>
        <div className='popover-icon-button-action'>
          <Button
            key='card-cancel-button'
            onClick={() => setVisible(false)}
          >
            {t('No')}
          </Button>
        </div>
      </div>
    </div>
  ), [t, content, onConfirm, checkedItem, storageKey])

  const BodyButton = useMemo(() => tooltipTitle ? TooltipIconButton : IconButton, [tooltipTitle])

  return (
    <div>
      <Popover
        overlayClassName='popover-icon-button'
        content={popoverContent}
        title={t(title)}
        trigger='click'
        visible={visible}
      >
        <BodyButton
          className={className}
          disabled={disabled ?? false}
          text={text}
          title={t(tooltipTitle)}
          type={type ?? 'default'}
          icon={icon}
          onClick={() => onSetVisble()}
        />
      </Popover>
    </div>
  )
}

export default connect(mapStateToProps)(PopoverIconButton)
